import {createApp} from 'vue'
import {ObserveVisibility} from 'vue-observe-visibility'

import RealEstateAgency from '~/default/vue/realestate/RealEstateAgency.vue'
import RealEstateGallery from '~/default/vue/realestate/RealEstateGallery.vue'

// RealEstateAgency
if (
  WC?.idMenu === 175 &&
  WC?.idLingua === 1 &&
  WC?.idCategoriaClienti === 42 &&
  WC?.idPaginaMenuMinisito === 11
) {
  const container = document.createElement('section')
  container.classList.add('vue--realestategallery')
  container.style.marginBottom = '30px'
  const target = document.querySelector('.artminisitoSci .boxheader .cuboSci1Content')

  if (target) {
    target.before(container)

    const app1 = createApp(RealEstateAgency)
    app1.mount(container)

    app1.directive('observe-visibility', {
      beforeMount: (el, binding, vnode) => {
        vnode.context = binding.instance
        ObserveVisibility.bind(el, binding, vnode)
      },
      update: ObserveVisibility.update,
      unmounted: ObserveVisibility.unbind,
    })
  }
}

// RealEstateGallery
if (WC?.idMenu === 37 && WC?.idLingua === 1 && WC.PageVars.showMinisitesGallery !== false) {
  if (WC.idPaginaMenuMinisito && WC.idPaginaMenuMinisito !== 1) {
    // municipality minisite could be a minisite or a single page article
    // if it is a minsite (and thus WC.idPaginaMenuMinisito exists) it makes sure the page id === 1
  } else {
    const container = document.createElement('section')
    container.classList.add('vue--realestategallery')
    const target = document.querySelector('.body-page #LbStampaErrori')

    if (target) {
      target.parentNode.insertBefore(container, target)

      const app2 = createApp(RealEstateGallery)
      app2.mount(container)
    }
  }
}
